<template lang="pug">
    div(style="height: 100%;")
        div.d-flex.info-area(v-if="items != null")
            sales-information
            receiver-dte(v-show="dteType==facturaId")
            .d-flex.justify-end.align-end.title(
              style="flex-direction: column;"
              v-if="payer && payer.toUpperCase() === 'SE'"
              )
              div.align-end.justify-end(style="20px; position: absolute;")
                v-chip(
                  color="primary"
                  avatar
                  style="") 
                  v-avatar.ma-0
                    v-icon.white--text account_circle
                  span.white--text.title Receptor: {{employeeName}}
</template>

<script>
import ItemStrip from '@/components/ItemStrip/ItemStrip'
import SaleInformation from '@/components/CashDesk/Detail/SaleInformation'
import Detail from '@/components/CashDesk/Detail/Detail'
import ReceiverDte from '@/components/CashDesk/Receiver/ReceiverDte'
import { mapState } from 'vuex'
export default {
    name: 'sale-details',
    props: {},
    data: function() {
        return {
            boletaId: 1,
            facturaId: 2,
        }
    },
    computed: {
        ...mapState('CashDeskModule', {
            items: 'saleDetail',
            dteType: 'posSaleType',
            payer: 'payer',
            saleEmployee: 'saleEmployee',
        }),
        employeeName() {
            return this.saleEmployee && this.saleEmployee.hr_employee
                ? this.saleEmployee.hr_employee.name_case
                : null
        },
    },
    methods: {},
    watch: {},
    components: {
        'sales-information': SaleInformation,
        detail: Detail,
        'receiver-dte': ReceiverDte,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.addBorder {
    border: solid black 2px;
}
.scroll {
    overflow-y: auto;
}
.resize {
    font-size: 10px !important;
}
.info-area {
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}
</style>
